<template>
  <div class="hospitalsCon">
    <span class="positioningPrompt">当前医院根据地理位置定位，如有偏差请选择更改医院</span>
    <div class="operation">
      <van-field class="checkCode" v-model="value" clearable placeholder="请输入姓名查询" />
      <div class="inquireData">
        <van-field
          v-model="value1"
          class="vanCell"
          clearable
          placeholder="请选择就诊时间"
          @focus="showPopup"
        />
        <!-- <van-cell is-link >展示弹出层</van-cell> -->
        <van-popup v-model="show" class="van-Date">
          <van-datetime-picker
            v-model="currentDate"
            type="date"
            @confirm="onConfirm"
            @cancel="onCancel"
          />
        </van-popup>
      </div>
    </div>
    <van-button type="primary" class="next" @click.native="onNext">下一步</van-button>
  </div>
</template>
<script>
import Storage from '@/tools/storage'
export default {
  props: ['hospitalsInfo'],
  name: 'inquireName',
  data() {
    return {
      value: '',
      value1: '',
      show: false,
      minDate: new Date(2020, 0, 1),
      maxDate: new Date(2025, 10, 1),
      currentDate: new Date()
    }
  },
  methods: {
    showPopup() {
      document.activeElement.blur()
      this.show = true
    },
    onCancel() {
      this.show = false
    },
    onConfirm(value) {
      console.log(value)
      let date = value
      let month = date.getMonth() + 1
      let strDate = date.getDate()
      if (month >= 1 && month <= 9) {
        month = '0' + month
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = '0' + strDate
      }
      this.value1 = date.getFullYear() + '' + month + '' + strDate
      this.show = false
    },
    onNext() {
      let params = {
        name: this.value,
        exam_datetime: this.value1,
        phone: Storage.get('phone'),
        institution_id: this.hospitalsInfo.id
      }
      this.$emit('getFuzzyReportInfo', params)
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
